<!--社区教育指导目录-->
<template>
    <div id="shequEdu">
        <div class="myflex content mt20 mb20">
            <div class="sec shequEdu-l pad15 mr20">
                <h4 class="shequEdu-l-title mb20 fon18 fweight">关于征集“全民终身学习网上社区教育大讲堂”的通知</h4>   
                <div class="shequEdu-l-con">
                    <p>为深入学习贯彻习近平总书记关于教育的重要论述和全国教育大会精神，落实党的十九大提出的“办好继续教育，加快建设学习型社会，大力提高国民素质”要求，根据《教育部办公厅关于举办2019年全民终身学习活动周的通知》安排，决定向社会征集社区大讲堂示范课程，推动各类学校和教育培训机构资源向社会开放，推动社区教育机构和老年教育机构联合行动，欢迎各位老师踊跃报名。</p>
                    <p class="">报名须知：只要您觉得自己的课程符合国家政策，符合教育部对艺术核心素养的提升要求，符合社区教育大讲堂的要求。您都可以邮件联系我们：art@artapp.cn</p></div>
            </div>
            <div class="sec flex1">
                <div class="tab-head myflex-v">
                    <div class="tab-item tabTitle myflex-v">
                        <i class="el-icon-pie-chart title-icon myhide"></i><img src="@/assets/img/icon5.png" class="title-icon-img" /><span>社区教育规范化活动目录</span>
                    </div>
                    <div class="sec-right-up myflex-v marginauto-l">
                        <div class="look-more" @click="toList">查看更多<i class="el-icon-arrow-right"></i></div>
                    </div>
                </div>
                <div class="pad15">
                    <div class="myflex-v mb20">
                        专业筛选：
                        <div class="myflex-v flexWrap" id="search-major-item-box">
                            <div class="search-major-item active" @click="searchMajor(0,'')">全部</div>
                            <div v-for="(majorItem,majorIndex) in codeList" :key="majorIndex"
                                class="search-major-item"
                                @click="searchMajor(majorIndex+1,majorItem.majorCode)">{{majorItem.majorName}}</div>
                        </div>
                    </div>
                    <div class="title-row myflex-v">
                        <div class="title-l">目录</div>
                        <div class="title-r marginauto-l">已选中/已征集</div>
                    </div>
                    <div class="list-box" v-if="catalogueList.length>0">
                        <div class="list-item w-100 myflex-v" v-for="(cItem1,cIndex1) in catalogueList" :key="cIndex1">
                            <i class="dot"></i>
                            <div class="list-text marginauto-l flex1 myflex-v">
                                <span class="major-label">{{cItem1.majorName}}</span>
                                <div class="flex1 list-course nowrap mr10">
                                    <span class="ellipsis1">{{cItem1.title}}</span>
                                    <span class="el-icon-s-flag hot-icon myhide"></span>
                                </div>
                                <div class="marginauto-l myflex-v">
                                    <div class="time-box mr15"><span class="c">{{cItem1.selectedNum}}</span>/{{cItem1.regNum}}</div>
                                    <span v-if="Date.now()<cItem1.endTime" class="zhengjiBtn" @click="joinZhengji(cItem1.id)">参与征集</span>
                                    <span v-else class="zhengjiBtn disabled">已截止</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="nodata pad15">暂无数据~</div>
                </div>
            </div>
        </div>
        <div class="content sec mb20 mt20 pad15 notice-box" v-show="zhengjiList && zhengjiList.length>0">
            <div class="notice-item" v-for="(zjItem,zjIndex) in zhengjiList" :key="zjIndex">{{zjItem.unit}}--<span class="theme-color">{{zjItem.userName}}</span>的《{{zjItem.courseName}}》被选中了<span></span>{{art.formatDate(zjItem.operateTime,4)}}</div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .shequEdu-l{width:350px;height:400px;min-width:350px;}
    .list-box{}
    .dot{width:5px;height:5px;background:$theme-color;margin:0 10px 0 5px;}
    .time-box{font-size:14px;color:$theme-color;font-weight:600;}
    .time-box .c{color:#666;font-weight:normal;}
    .list-item{cursor:pointer;}
    .list-text{border-bottom:1px dashed #ddd;padding:10px 0px 10px 0;}
    .list-item:last-child .list-text{border-bottom:none;}
    .list-course .ellipsis1{display:inline-block;max-width:540px;}
    .search-major-item{padding:1px 2px;color:#fff;background:#aaa;margin-right:10px;font-size:12px;cursor:pointer;}
    .search-major-item.active{background:$theme-color;}
    .pt0{padding-top:0;}
    .major-label{padding:1px 2px;color:#fff;background:#aaa;margin-right:5px;font-size:12px;} 
    .hot-icon{color:#e0643e;font-size:18px;} 
       .zhengjiBtn{border-radius:12px;background:$theme-color;color:#fff;padding:2px 3px;line-height:1;display:inline-block;min-width:60px;text-align:center;
        -webkit-box-shadow:0 1px 1px 1px rgba(44,118,193,.2);box-shadow:0 1px 1px 1px rgba(44,118,193,.2);cursor:pointer;}
    .zhengjiBtn.disabled{background:#aaa;cursor:auto;}
    .title-row{font-weight:600;margin-bottom:5px;}
    .title-r{margin-right:76px;}
    .title-l{margin-left:20px;}

    .notice-box{overflow:hidden;overflow-x:auto;min-height:100px;}
    .notice-item{display:inline-block;border:1px solid #ddd;background:#f7f7f7;line-height:1;padding:6px 13px;margin:6px 10px 6px 0;
        border-radius:18px;color:#666;}
    .shequEdu-l-con{text-indent:2em;line-height:1.8;}
</style>

<script>
import CourseListItem from '@/components/CourseListItem.vue';
export default {
    name: "shequCourse",
    components: {
        CourseListItem,
    },
    data(){
        return {
            art: art,
            catalogueList:[],
            codeList: [],
            curMajorCode: '',
            zhengjiList: [], 
        }
    },
    computed:{
        cityName: {
            get(){
                return this.$store.state.cityInfo.cityName;
            },
            set(){

            }
        }
    },
    methods: {
        //选择专业
        searchMajor: function(ind,code){
            art('#search-major-item-box .search-major-item').removeClass('active');
            art(art('#search-major-item-box .search-major-item').ele[ind]).addClass('active');
            this.curMajorCode = code;
            this.getCatalogueList();
        },

        //获取专业
        getMajorList(){
            this.$api.web.websitContentSelectCourseCollectionCode({}).then(res=>{
                let d = res.body.codeList;
                this.codeList = d;
                setTimeout(()=>{
                    this.searchMajor(0,'');
                },10)
            }).catch(res=>{})
        },

        //获取征集列表
        getCatalogueList(){
            var data = {
                pageNum: 1,
                pageSize: 6,
                majorCode:this.curMajorCode
            }
            this.$api.web.websitContentSelectCourseCollectionCatalogueList(data).then(res=>{
                this.catalogueList = res.body.catalogueList;
            }).catch(res=>{})
        },

        //参与征集
        joinZhengji(id){
            const newurl = this.$router.resolve({path: '/collectDetail', query: {id: id}})
            window.open(newurl.href,'_blank');
        },

        //征集明细
        getZhengjiList(){
            this.$api.web.websitContentSelectCourseCollectionAuditPass({}).then(res=>{
                this.zhengjiList = res.body.courseCollectionList;
            }).catch(res=>{})
        },

        //跳到活动列表页面
        toList(){
            const newurl = this.$router.resolve({path: '/catalogList', query: {}})
            window.open(newurl.href,'_blank');
        },
    },
    created(){
    },
    mounted(){
        this.getMajorList();
        setTimeout(()=>{
            this.getZhengjiList();
        },500)
    }
}
</script>